const NODESALE_ABI = [
  {
    type: 'function',
    name: 'CREATE_PROJECT_ROLE',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'DEFAULT_ADMIN_ROLE',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'ERC20_PRICE_FEED_DISCOUNT_TYPEHASH_UPDATED',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'ETH_PRICE_FEED_DISCOUNT_TYPEHASH_UPDATED',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'GALA_PRICE_FEED_DISCOUNT_TYPEHASH_UPDATED',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'NODE_PRICE_DECIMAL',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'PRICE_FEEDER',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'UPGRADE_INTERFACE_VERSION',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'string',
        internalType: 'string',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'USDC_PRICE_FEED_DISCOUNT_TYPEHASH_UPDATED',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'USDT_PRICE_FEED_DISCOUNT_TYPEHASH_UPDATED',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'addProjectTierPrice',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_border',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
      {
        name: '_price',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'buyByERC20',
    inputs: [
      {
        name: '_usdValueMax',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: '_signature',
        type: 'tuple',
        internalType: 'struct NodeSaleSupportMultiERC20.SignatureUpdatedERC20',
        components: [
          {
            name: 'nft',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'buyer',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'erc20',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'price',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'decimals',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'v',
            type: 'uint8',
            internalType: 'uint8',
          },
          {
            name: 'r',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'signature',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'buyByETH',
    inputs: [
      {
        name: '_usdValueMax',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: '_signature',
        type: 'tuple',
        internalType: 'struct NodeSaleSupportMultiERC20.SignatureUpdated',
        components: [
          {
            name: 'nft',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'buyer',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'price',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'decimals',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'v',
            type: 'uint8',
            internalType: 'uint8',
          },
          {
            name: 'r',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'signature',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'buyByGala',
    inputs: [
      {
        name: '_usdValueMax',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: '_signature',
        type: 'tuple',
        internalType: 'struct NodeSaleSupportMultiERC20.SignatureUpdated',
        components: [
          {
            name: 'nft',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'buyer',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'price',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'decimals',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'v',
            type: 'uint8',
            internalType: 'uint8',
          },
          {
            name: 'r',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'signature',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'buyByUSDC',
    inputs: [
      {
        name: '_usdValueMax',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: '_signature',
        type: 'tuple',
        internalType: 'struct NodeSaleSupportMultiERC20.SignatureUpdated',
        components: [
          {
            name: 'nft',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'buyer',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'price',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'decimals',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'v',
            type: 'uint8',
            internalType: 'uint8',
          },
          {
            name: 'r',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'signature',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'buyByUSDT',
    inputs: [
      {
        name: '_usdValueMax',
        type: 'uint64',
        internalType: 'uint64',
      },
      {
        name: '_signature',
        type: 'tuple',
        internalType: 'struct NodeSaleSupportMultiERC20.SignatureUpdated',
        components: [
          {
            name: 'nft',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'buyer',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'amount',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'price',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'decimals',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'v',
            type: 'uint8',
            internalType: 'uint8',
          },
          {
            name: 'r',
            type: 'bytes32',
            internalType: 'bytes32',
          },
          {
            name: 'signature',
            type: 'bytes32',
            internalType: 'bytes32',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'createProject',
    inputs: [
      {
        name: '_params',
        type: 'tuple',
        internalType: 'struct INodeSale.CreateProjectParams',
        components: [
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'description',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'website',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'termsOfServiceLink',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'projectImage',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'uri',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'admin',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'startSaleTimestamp',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'fee',
            type: 'uint64',
            internalType: 'uint64',
          },
        ],
      },
      {
        name: '_border',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
      {
        name: '_price',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'getProjectFund',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct INodeSale.ProjectFund',
        components: [
          {
            name: 'lock',
            type: 'bool',
            internalType: 'bool',
          },
          {
            name: 'accETH',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'accUSDT',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'accUSDC',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'accGala',
            type: 'uint256',
            internalType: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getProjectInfo',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct INodeSale.ProjectInfo',
        components: [
          {
            name: 'name',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'description',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'website',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'termsOfServiceLink',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'projectImage',
            type: 'string',
            internalType: 'string',
          },
          {
            name: 'admin',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'creator',
            type: 'address',
            internalType: 'address',
          },
          {
            name: 'startSaleTimestamp',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'fee',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'cap',
            type: 'uint64',
            internalType: 'uint64',
          },
          {
            name: 'sold',
            type: 'uint64',
            internalType: 'uint64',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getProjectTierPrice',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: 'border',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
      {
        name: 'price',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getProjectsLength',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getRoleAdmin',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getUSDValue',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_amount',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    outputs: [
      {
        name: 'usdValue',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'grantRole',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'hasRole',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'nfts',
    inputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'nonce',
    inputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'projectFundERC20',
    inputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'proxiableUUID',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'renounceRole',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'callerConfirmation',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'revokeRole',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        internalType: 'bytes32',
      },
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setFeeTo',
    inputs: [
      {
        name: '_feeTo',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setUnlockTransferTime',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_unlockTime',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'supportsInterface',
    inputs: [
      {
        name: 'interfaceId',
        type: 'bytes4',
        internalType: 'bytes4',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'bool',
        internalType: 'bool',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'unlockFund',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'unlockFundERC20',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_erc20s',
        type: 'address[]',
        internalType: 'address[]',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateProjectAdmin',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_newAdmin',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateProjectTierPrice',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_border',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
      {
        name: '_price',
        type: 'uint64[]',
        internalType: 'uint64[]',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'upgradeToAndCall',
    inputs: [
      {
        name: 'newImplementation',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'data',
        type: 'bytes',
        internalType: 'bytes',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'withdraw',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'withdrawERC20',
    inputs: [
      {
        name: '_nft',
        type: 'address',
        internalType: 'address',
      },
      {
        name: '_erc20s',
        type: 'address[]',
        internalType: 'address[]',
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    name: 'BuyBuyGala',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'galaValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'BuyByERC20',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'erc20',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'usdValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'erc20Value',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'BuyByETH',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'ethValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'BuyByUSDC',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdcValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'BuyByUSDT',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'usdtValue',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'CreateProject',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'name',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'description',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'website',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'termsOfServiceLink',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'projectImage',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'uri',
        type: 'string',
        indexed: false,
        internalType: 'string',
      },
      {
        name: 'admin',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'startSaleTimestamp',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'fee',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
      {
        name: 'cap',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'IncreaseNonce',
    inputs: [
      {
        name: 'buyer',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Initialized',
    inputs: [
      {
        name: 'version',
        type: 'uint64',
        indexed: false,
        internalType: 'uint64',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ProjectTierPriceAdd',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'border',
        type: 'uint64[]',
        indexed: false,
        internalType: 'uint64[]',
      },
      {
        name: 'price',
        type: 'uint64[]',
        indexed: false,
        internalType: 'uint64[]',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ProjectTierPriceUpdate',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'border',
        type: 'uint64[]',
        indexed: false,
        internalType: 'uint64[]',
      },
      {
        name: 'price',
        type: 'uint64[]',
        indexed: false,
        internalType: 'uint64[]',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RoleAdminChanged',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'previousAdminRole',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'newAdminRole',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RoleGranted',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RoleRevoked',
    inputs: [
      {
        name: 'role',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SetFeeTo',
    inputs: [
      {
        name: 'feeTo',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SetPayment',
    inputs: [
      {
        name: 'token',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'enable',
        type: 'bool',
        indexed: false,
        internalType: 'bool',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SetUnlockTransferTime',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
      {
        name: 'time',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'UnlockFund',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'accETH',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accUSDT',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accUSDC',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accGala',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'UnlockFundERC20',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'erc20',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'UpdateProjectAdmin',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'admin',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Upgraded',
    inputs: [
      {
        name: 'implementation',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Withdraw',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'accETH',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accUSDC',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accUSDT',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
      {
        name: 'accGala',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WithdrawERC20',
    inputs: [
      {
        name: 'nft',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'erc20',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'amount',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
  {
    type: 'error',
    name: 'AccessControlBadConfirmation',
    inputs: [],
  },
  {
    type: 'error',
    name: 'AccessControlUnauthorizedAccount',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'neededRole',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'AddressEmptyCode',
    inputs: [
      {
        name: 'target',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'AddressInsufficientBalance',
    inputs: [
      {
        name: 'account',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'CallerIsNotUpdator',
    inputs: [],
  },
  {
    type: 'error',
    name: 'Deadline',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ECDSAInvalidSignature',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ECDSAInvalidSignatureLength',
    inputs: [
      {
        name: 'length',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
  },
  {
    type: 'error',
    name: 'ECDSAInvalidSignatureS',
    inputs: [
      {
        name: 's',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'ERC1967InvalidImplementation',
    inputs: [
      {
        name: 'implementation',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'ERC1967NonPayable',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ExceedCap',
    inputs: [],
  },
  {
    type: 'error',
    name: 'FailedInnerCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InsufficientETH',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidAmount',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidBorder',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidBuyer',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidERC20',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidFee',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidInitialization',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidNonce',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidPayment',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidPrice',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidProjectAdmin',
    inputs: [],
  },
  {
    type: 'error',
    name: 'InvalidTime',
    inputs: [],
  },
  {
    type: 'error',
    name: 'NotInitializing',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ParamsNotMatch',
    inputs: [],
  },
  {
    type: 'error',
    name: 'Permissionless',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ReentrancyGuardReentrantCall',
    inputs: [],
  },
  {
    type: 'error',
    name: 'SafeERC20FailedOperation',
    inputs: [
      {
        name: 'token',
        type: 'address',
        internalType: 'address',
      },
    ],
  },
  {
    type: 'error',
    name: 'SignatureHasUsed',
    inputs: [],
  },
  {
    type: 'error',
    name: 'Slippage',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UUPSUnauthorizedCallContext',
    inputs: [],
  },
  {
    type: 'error',
    name: 'UUPSUnsupportedProxiableUUID',
    inputs: [
      {
        name: 'slot',
        type: 'bytes32',
        internalType: 'bytes32',
      },
    ],
  },
  {
    type: 'error',
    name: 'Unlocked',
    inputs: [],
  },
  {
    type: 'error',
    name: 'ZeroAddress',
    inputs: [],
  },
];

export { NODESALE_ABI };
